"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoEvents = exports.VideoConstants = exports.PresentationTypes = void 0;
var VideoConstants = exports.VideoConstants = Object.freeze({
  DeliveryType: {
    DEFAULT: 'default',
    MICROSOFT_ECDN: 'microsoft_ecdn',
    HIVE: 'hive',
    RAMP: 'ramp'
  },
  DeliveryTypeLabels: {
    "default": 'Default',
    microsoft_ecdn: 'Microsoft eCDN',
    hive: 'Hive',
    ramp: 'Ramp'
  },
  SentimentDefaults: {
    enabled: false,
    orientation: 'horizontal',
    placement: 'bottomleft'
  },
  VideoType: {
    LIVE: 'live',
    PRERECORDED: 'prerecorded'
  }
});
var VideoEvents = exports.VideoEvents = Object.freeze({
  COMPONENT_EVENT: 'component.event',
  ERROR_EVENT: 'error',
  RETRYPLAYLIST_EVENT: 'retryplaylist',
  BLACKLISTPLAYLIST_EVENT: 'blacklistplaylist',
  DISPOSE_EVENT: 'dispose',
  READY_EVENT: 'ready',
  PLAYING_EVENT: 'playing',
  CLICK_EVENT: 'click'
});

/**
 * Presentation types will determine some aspects of configuration
 */
var PresentationTypes = exports.PresentationTypes = Object.freeze({
  LIVE: 'live',
  ARCHIVE: 'archive'
});